import oBannerFeatureEditorialModel from './OBannerFeatureEditorial.model.json';
import { OBannerFeatureEditorialProps } from '../OBannerFeatureEditorial.types';

export const oBannerFeatureEditorialMockData = oBannerFeatureEditorialModel as OBannerFeatureEditorialProps;
